import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { PreviewSite } from "@/components/iv/concept/PreviewSite";

const setMeta = (name, content) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

export default function PreviewPage() {
  const { slug } = useParams();
  const [preview, setPreview] = useState(null);
  const [missing, setMissing] = useState(null);
  useEffect(() => {
    setMeta("robots", "noindex, nofollow");
    document.querySelector('link[rel="canonical"]')?.remove();
    api.get(`/previews/${slug}`).then((r) => { setPreview(r.data); document.title = `${r.data.brand_name} — Test Preview`; }).catch((e) => setMissing(e.response?.status === 410 ? "expired" : "missing"));
  }, [slug]);
  if (missing === "expired") return (
    <main className="grid min-h-screen place-items-center bg-slate-50 px-5 text-center" data-testid="preview-page-expired">
      <div className="max-w-md space-y-4">
        <h1 className="text-2xl font-bold text-slate-900">This preview has expired — your report is still in your workspace</h1>
        <a href="/?stage=3" className="inline-flex rounded-full bg-slate-900 px-5 py-2.5 text-sm font-semibold text-white" data-testid="preview-page-expired-cta">Open my workspace</a>
      </div>
    </main>
  );
  if (missing) return <main className="grid min-h-screen place-items-center bg-white text-slate-700" data-testid="preview-page-missing">Preview not found.</main>;
  if (!preview) return <main className="min-h-screen bg-white" data-testid="preview-page-loading" />;
  return (
    <main className="min-h-screen bg-slate-50" data-testid="preview-page">
      <PreviewSite spec={preview.site_spec_json} imageUrl={preview.mockup_image_url} />
      <footer className="px-5 py-4 text-center text-[11px] text-slate-500">Test preview built with IdeaValidator360</footer>
    </main>
  );
}
